export const actions = {
    trackPageUsageStart({ state }, name) {
        if (state.insights) {
            state.insights.startTrackPage(name);
        }
    },
    trackPageUsageStop({ state, getters }, name) {
        if (state.insights) {
            const meta = getters.getUsageMeta;
            state.insights.stopTrackPage(name, window.location.href, { ...meta });
        }
    },
    trackRapportageEvent({ dispatch, getters }, usageData) {
        const meta = getters.getUsageMeta;
        const data = { ...usageData, ...meta };
        dispatch('trackUserEvent', data);
    },
    async logAvgUsage({ dispatch }, { avgLogData }) {

        // filter out BSN rights message
        if (avgLogData.BSN === 'U heeft geen rechten om BSN gegevens in te zien.') {
            avgLogData.BSN = null;
        }

        // In order to store the AVG log we need to have at least:
        // a BSN
        // or a Naam
        // or an Email
        if (avgLogData.BSN || avgLogData.Naam || avgLogData.Email) {
            await dispatch('useApiData', {
                name: 'CreateAvgLog',
                data: avgLogData
            });
        }
    }
};
